import { createSlice } from '@reduxjs/toolkit';

const tabSlice = createSlice({
    name: 'tabs',
    initialState: {
        activeTab: 0
    },
    reducers: {
        setActiveTabs: (state = {}, actionType = {}) => {
            const { payload = {} } = actionType;
            return { ...state, ...payload }
        }
    }
});
const { actions, reducer } = tabSlice;
export default reducer;
export const tabActions = actions;
